// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1Ng0SpH2WlMxTsCMMhl6HJ{background:#e6f4f1}", "",{"version":3,"sources":["webpack://./resources/js/components/PostCard/styles.module.scss"],"names":[],"mappings":"AAAA,yBACI,kBACJ","sourcesContent":[".is_paid {\n    background: #e6f4f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"is_paid": "_1Ng0SpH2WlMxTsCMMhl6HJ"
};
export default ___CSS_LOADER_EXPORT___;
